import React from 'react';
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import {
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Input
} from 'reactstrap';
import { API_ENDPOINT } from '../constants';
import warrning from '../assets/svg/warrning.svg'
import info from '../assets/svg/info.svg'
import ErrorModal from './errorModal';
import QRCode from "react-qr-code";
import bankID from '../assets/images/icon-bankid2.png';
import deeplink from './browserDeeplink'
import { getSearchParams } from '../helpers/linkHelper';

function parseBankIdUrl(url) {
    if (!url) return {}
    // Create an empty object to hold the parsed query parameters
    const result = {};

    // Check if the URL contains a query string
    const queryString = url.split('?')[1];
    if (!queryString) return result;

    // Split the query string into key-value pairs
    const pairs = queryString.split('&');

    // Iterate over the pairs and extract the key-value
    pairs.forEach(pair => {
        const [key, value] = pair.split('=');
        result[key] = value;
    });

    return result;
}

class BankIDModal_v6 extends React.Component {

    constructor(props) {
        super(props);
        this.linkTag = React.createRef();
        this.imageQRcode = React.createRef();
        this.state = {
            personalNumber: '',
            error: false,
            qrCodeLink: null,
            personalNumber: '',
            redirect_url: false,
            data: false,
            showHelpDropDown: false,
            showReaderDropDown: false,
            qrCodeExpired: false,
            qrCodeTimeExpiration: 1
        }
        this.componentUnmounted = false;
    }

    componentDidMount() {

        const userAgent = navigator?.userAgent?.toLowerCase();
        const mobileDevices = /(iphone|ipad)/i;
        const isMobile = mobileDevices?.test(userAgent);
        if (isMobile !== this.state.isMobile) {
            this.setState({ isMobile })
        }
        this.logIn()

        let alias = this.props.alias;
        let mainAlias = this.props.mainAlias;
        if (mainAlias && alias && alias !== 'noGroupAlias') {
            fetch(API_ENDPOINT + '/landing/page', {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ alias, mainAlias })
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.props[0].history.push('/')
                } else {
                    this.setState({
                        data: result
                    }, () => {
                        if (result.favicon) {
                            let favicon = document.getElementById("favicon");
                            favicon.href = result.favicon;
                        } else if (result.logoChat) {
                            let favicon = document.getElementById("favicon");
                            favicon.href = result.logoChat;

                        } else {
                            favicon.href = '/favicon.ico';
                        }
                    })

                }
            });



        } else if (alias && alias !== 'noGroupAlias') {
            fetch(API_ENDPOINT + '/landing/page', {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ alias })
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.props[0].history.push('/')
                } else {
                    // console.log(result)
                    this.setState({
                        data: result
                    }, () => {

                        if (result.favicon) {
                            let favicon = document.getElementById("favicon");
                            favicon.href = result.favicon;
                        } else if (result.logoChat) {
                            let favicon = document.getElementById("favicon");
                            favicon.href = result.logoChat;

                        } else {
                            favicon.href = '/favicon.ico';
                        }
                    })

                }
            });
        }

        window.addEventListener('message', (e) => {
            if (this.props.doctorLogin) {
                if (e.data == 'loggedin') {

                    this.props.verifyUser(() => {
                        this.props.registerClinicGroupLogs({
                            type: 'login',
                            loginType: 'bankid'
                        })
                        this.props[0].history.push('/');


                    }, () => {


                        if (this.props.uData && this.props.uData.clinicGroups && this.props.uData.clinicGroups.length) {
                            let arr = [];
                            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                                arr.push(this.props.uData.clinicGroups[i]);
                            }
                            if (this.state.data && arr.filter((item) => item?._id == this.state.data?._id).length == 0) {
                                this.props.changeGroup(arr[0]?._id);
                                localStorage.setItem('groupAlias', arr[0]?.alias);
                            } else if (this.state.data) {
                                this.props.changeGroup(this.state.data?._id);
                            } else {
                                this.props.changeGroup(arr[0]?._id);
                            }
                        } else if (this.state.data) {
                            this.props.changeGroup(this.state.data?._id);
                        }


                    });

                } else if (e.data == 'loggedin_newuser') {


                    this.props.verifyUser(() => {
                        this.props.registerClinicGroupLogs({
                            type: 'login',
                            loginType: 'bankid'
                        })
                        this.props[0].history.push('/');
                        // console.log(this.props.uData)
                    }, () => {
                        if (this.props.uData && this.props.uData.clinicGroups && this.props.uData.clinicGroups.length) {
                            let arr = [];
                            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                                arr.push(this.props.uData.clinicGroups[i]);
                            }
                            if (this.state.data && arr.filter((item) => item?._id == this.state.data?._id).length == 0) {
                                this.props.changeGroup(arr[0]?._id)
                                localStorage.setItem('groupAlias', arr[0]?.alias);
                            } else if (this.state.data) {
                                this.props.changeGroup(this.state.data?._id)
                            } else {
                                this.props.changeGroup(arr[0]?._id)
                            }
                        } else if (this.state.data) {
                            this.props.changeGroup(this.state.data?._id)
                        }




                    });
                }
            } else {
                if (this.componentUnmounted) {
                    return;
                }
                if (e.data == 'loggedin') {

                    localStorage.setItem('loginLandingPage', true);
                    localStorage.setItem('logoutLandingPage', true);
                    if (localStorage.getItem('groupAlias'))
                        localStorage.setItem('loginGroupAlias', localStorage.getItem('groupAlias'));
                    let setVerifyRedirectLink;
                    if (this.props.setVerifyRedirectLink) {
                        setVerifyRedirectLink = this.props.setVerifyRedirectLink
                    }

                    this.props.verifyUser((uData) => {
                        if (this.props.navigateToMyChildren && (this.props?.uData?.userLevel == 2 || (this.props?.uData?.userLevel == 20 && typeof window !== 'undefined' && localStorage?.getItem?.('profile') == 'patient'))) return;
                        if (this.props.openLastLoginLanding && this.props.clinicGroupsItems && this.props.clinicGroupsItems.length) {
                            if (uData && uData.lastVisitedGroups && uData.lastVisitedGroups.length) {
                                let lastVisitedGroups = uData.lastVisitedGroups.reverse();
                                for (let i = 0; i < lastVisitedGroups.length; i++) {
                                    if (this.props.clinicGroupsItems.filter(el => el.alias == lastVisitedGroups[i].alias).length) {
                                        alias = lastVisitedGroups[i].alias;
                                        break;
                                    }
                                }
                                let alias;
                                if (alias) {
                                    this.props.toggle(alias);
                                } else {
                                    this.props.toggle();
                                }
                            } else {
                                this.props.toggle();
                            }
                        } else {
                            this.props.toggle();
                        }

                    }, null, false, () => {
                        if (this.props.navigateToMyChildren && (this.props?.uData?.userLevel == 2 || (this.props?.uData?.userLevel == 20 && typeof window !== 'undefined' && localStorage?.getItem?.('profile') == 'patient'))) {
                            this.props?.[0]?.history?.push?.(
                                '/my-data/account',
                                { navigateToMyChildren: true }
                            );
                        } else {
                            if (setVerifyRedirectLink) setVerifyRedirectLink()
                        }
                    });

                } else if (e.data == 'loggedin_newuser') {
                    localStorage.setItem('loginLandingPage', true);
                    localStorage.setItem('logoutLandingPage', true);
                    if (localStorage.getItem('groupAlias'))
                        localStorage.setItem('loginGroupAlias', localStorage.getItem('groupAlias'));

                    let setVerifyRedirectLink;
                    if (this.props.setVerifyRedirectLink) {
                        setVerifyRedirectLink = this.props.setVerifyRedirectLink
                    }

                    this.props.verifyUser(() => {
                        if (this.props.navigateToMyChildren && (this.props?.uData?.userLevel == 2 || (this.props?.uData?.userLevel == 20 && typeof window !== 'undefined' && localStorage?.getItem?.('profile') == 'patient'))) return;
                        if (this.props.toggle) this.props.toggle();
                    }, null, true, () => {
                        if (this.props.navigateToMyChildren && (this.props?.uData?.userLevel == 2 || (this.props?.uData?.userLevel == 20 && typeof window !== 'undefined' && localStorage?.getItem?.('profile') == 'patient'))) {
                            this.props?.[0]?.history?.push?.(
                                '/my-data/account',
                                { navigateToMyChildren: true }
                            );
                        } else {
                            if (setVerifyRedirectLink) setVerifyRedirectLink()
                        }
                    });
                    this.setState({
                        loggedIn: true
                    })

                }
            }

        }, false)

        let params = getSearchParams(this.props[0].location.search);

        if (params && params.key) {
            let key = params.key
            this.interval = setInterval(() => {
                if (!this.checkBankIdKey) {
                    this.checkBankId(key, (data) => {
                        if (data.token) {
                            this.setState({ loading: null }, () => {
                                clearInterval(this.interval);

                            })
                        }
                    });
                }

            }, 2000);
        }
        // window.addEventListener("scroll", this.onScroll, { passive: true });
        // window.addEventListener("resize", this.onResize, { passive: true });
        window.addEventListener("keydown", this.onKeyDown, { capture: true }); // capture gets it early
    }

    onKeyDown = (e) => {
        // ignore when typing in inputs/editors
        // const tgt = e.target;
        // if (tgt && (tgt.closest('input, textarea, [contenteditable="true"]'))) return;
        // detect Space
        if (e.code === "Space" || e.key === " ") {

            if (e.repeat) return;
            if (this.componentUnmounted) return;
            if (this.state.qrCodeTimeExpiration && (300 - 2 * this.state.qrCodeTimeExpiration) <= 30) {


                if (e.code === 'Space' || e.key === ' ' || e.keyCode === 32) {
                    e.preventDefault();

                    this.setState({
                        qrCodeExpired: false,
                        qrCodeTimeExpiration: 1
                    }, () => {
                        this.logIn()
                        if (this.qrCodeButton) {
                            this.qrCodeButton.focus({ preventScroll: true })
                        }

                    })
                }

            }
        }
    }

    logIn = () => {
        if (this.interval) {
            clearInterval(this.interval)
        }

        this.setState({
            loading: true,
            qrCodeExpired: false,
            qrCodePendingSign: false
        })
        this.generateBankIdAppURL((key, redirect_url) => {

            this.setState({
                loading: false
            }, () => {

                const qrCodeLink = this.state.qrCodeLink;
                const imageElement = document.getElementById('qr-image');
                let t = 0;

                this.interval = setInterval(() => {

                    if (t === 14) {
                        clearInterval(this.interval);
                        this.logIn();
                        t = 0;
                    }

                    if (!this.checkBankIdKey) {
                        this.checkBankId(key, (data) => {
                            if (data.token) {
                                this.setState({ loading: null }, () => {
                                    clearInterval(this.interval);

                                })
                            }
                        });
                    }
                    if (imageElement)
                        imageElement.setAttribute('src', qrCodeLink + '&t=' + t);
                    t++;
                    this.setState({
                        qrCodeTimeExpiration: this.state.qrCodeTimeExpiration + 1
                    }, () => {
                        if (this.state.qrCodeTimeExpiration === 150) {
                            clearInterval(this.interval)
                            this.setState({
                                qrCodeExpired: true
                            })
                        }
                    })
                }, 2000);
            })

        })
        this.setState({
            error: false
        })

    }

    componentDidUpdate(prevProps) {
        // if (this.state.qrCodeLink && this.qrImage && !this.state.mode && this.state.imageLoaded) {
        //     this.updateMode()
        // }

        // if (this.props.mode && prevProps.mode && prevProps.mode !== this.props.mode) {
        //     this.setState({
        //         mode: this.props.mode
        //     })
        // }
    }

    componentWillUnmount() {
        this.componentUnmounted = true;
        if (this.interval) {
            clearInterval(this.interval)
        }

        // window.removeEventListener("scroll", this.onScroll);
        // window.removeEventListener("resize", this.onResize);
        window.removeEventListener("keydown", this.onKeyDown);
    }

    generateBankIdAppURL = (callback) => {
        fetch(API_ENDPOINT + '/users/bankid/v5/web/start', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({ group: this.props.group, alias: this.props.alias, bundleId: this.props.bundle })
        }).then(res => {
            return res.json()
        }).then((result) => {
            if (result.redirect_url) {
                if (result.qrCodeLink) {
                    this.setState({
                        qrCodeLink: result.qrCodeLink,
                        redirect_url: result.redirect_url
                    })

                }

                callback(result.key, result.redirect_url)
            } else if (result.error) {
                this.setState({
                    errorBankID: result.error?.translate(this.props.lang)
                })
            }

        })
    }

    checkBankIdKeyAgain = (key) => {
        setTimeout(() => {
            this.checkBankId(key, (data) => {
                if (data.token) {
                    this.setState({ loading: null })
                }
            });
        }, 2000)
    }

    checkBankId = async (key, callback) => {

        this.checkBankIdKey = true;

        fetch(API_ENDPOINT + '/users/bankid/v5/check', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({ key: key, group: this.props.group, alias: this.props.alias, connect: this.props.connect })
        }).then(res => res.json()).then(async (result) => {
            if (result && result.pending) {
                this.setState({
                    qrCodePendingSign: true,
                    loading: true
                }, () => {
                    if (this.interval) {
                        clearInterval(this.interval)
                    }

                    this.checkBankIdKeyAgain(key)
                })
            }
            if (result && result.failed) {
                this.setState({
                    qrCodeExpired: true,
                    loading: false
                }, () => {
                    if (this.interval)
                        clearInterval(this.interval);
                })
            }
            if (this.checkBankIdKey) {
                this.checkBankIdKey = null;
            }
            if (result.sessionId && result.token) {
                if (result.error) {
                    this.setState({
                        error: result.error
                    })
                } else {
                    try {
                        if (result?.userData && typeof window !== 'undefined') {
                            localStorage?.setItem?.('userData', JSON.stringify(result?.userData));
                        }
                    } catch (err) {
                        console.error('login user data err: ', err);
                    }
                    if (this.props.doctorLogin) {
                        localStorage.setItem('authToken', result.token);
                        localStorage.setItem('time', Math.floor(Date.now() / 1000))
                        localStorage.setItem('profile', 'doctor');
                        localStorage.setItem('userLevel', 20);
                        localStorage.setItem('logoutLandingPage', true);
                        this.props.registerLog('Logged in');
                        this.props.verifyUser(() => {
                            this.props.registerClinicGroupLogs({
                                type: 'login',
                                loginType: 'username'
                            })
                            if (this.props.uData && this.props.uData.clinicGroups && this.props.uData.clinicGroups.length) {
                                let arr = [];
                                for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                                    arr.push(this.props.uData.clinicGroups[i]);
                                }
                                localStorage.setItem('groupAlias', this.props.alias);
                            } else {
                                localStorage.setItem('groupAlias', this.props.alias);
                            }
                            if (this.props.uData && this.props.uData.userLevel) {
                                localStorage.setItem('userLevel', this.props.uData.userLevel);
                            }
                            localStorage.setItem('loginGroupAlias', this.props.alias);
                            this.props[0].history.push(`/`);
                        }, () => {
                            if (localStorage.getItem('loginGroupAlias') == localStorage.getItem('groupAlias') && this.state.data && localStorage.getItem('groupAlias') !== 'noGroupAlias') {
                                this.props.changeGroup(this.state.data?._id);
                            } else {
                                let arr = [];
                                if (this.props?.uData?.clinicGroups?.length) {
                                    for (let i = 0; i < this.props?.uData?.clinicGroups?.length; i++) {
                                        arr.push(this.props.uData.clinicGroups[i]);
                                    }
                                }
                                if (arr && arr.length > 0 && arr[0]) this.props.changeGroup(arr[0]?._id);
                            }

                        });
                    } else {
                        if (window.top) {
                            if (result.newUser) {
                                window.top.postMessage('loggedin_newuser', '*')

                            } else {
                                window.top.postMessage('loggedin', '*')
                            }
                            if (this.interval) {
                                clearInterval(this.interval)
                            }
                        }

                        if (result.sessionId) {
                            localStorage.setItem('sessionId', result.sessionId)
                        }

                        localStorage.setItem('authToken', result.token);
                        localStorage.setItem('time', Math.floor(Date.now() / 1000))
                        localStorage.setItem('profile', 'doctor');
                        if (localStorage.getItem('groupAlias')) {
                            localStorage.setItem('logoutLandingPage', true);
                            localStorage.setItem('loginGroupAlias', localStorage.getItem('groupAlias'));
                        } else if (this.props.alias) {
                            localStorage.setItem('groupAlias', this.props.alias)
                            localStorage.setItem('logoutLandingPage', true);
                            localStorage.setItem('loginGroupAlias', this.props.alias);
                        }
                        if (!this.props.toggle) {
                            if (result.message) {
                                this.props[0].history.push({
                                    pathname: '/my-data/account',
                                    state: { bankIdError: result.message }
                                })
                            } else {
                                window.location.href = "/"
                            }
                        }
                    }




                }
            }

            if (this.props.connect && result.success) {
                if (this.props.goBack)
                    this.props.goBack()
            }

            callback(result)
        }).catch((e) => {
            if (this.checkBankIdKey) {
                this.checkBankIdKey = null;
            }
        });
    }

    // onResize = () => {
    //     this.setState({
    //         mode: 'normal'
    //     }, () => this.updateMode())


    // };

    // onScroll = () => {
    //     // this.setState({
    //     //     mode: 'normal'
    //     // }, () => this.updateMode())
    //     this.updateMode()
    // };

    // updateMode = () => {
    //     const el = this.qrImage;
    //     if (!el) return;
    //     let edgeOffset = 5
    //     const rect = el.getBoundingClientRect();
    //     if (this.props.mode && this.props.updateModeInModal) {
    //         this.props.updateModeInModal()
    //     }
    //     // If the element's top touches or goes above viewport top -> stick top
    //     if (rect.top <= edgeOffset) {
    //         if (this.state.mode !== "top" || !this.state.mode) this.setState({ mode: "top" });
    //         return;
    //     }

    //     // If the element's bottom touches or goes below viewport bottom -> stick bottom
    //     if (rect.bottom > window.innerHeight) {
    //         if (this.state.mode !== "bottom" || !this.state.mode) this.setState({ mode: "bottom" });
    //         return;
    //     }

    //     // Otherwise normal flow
    //     if (this.state.mode !== "normal") this.setState({ mode: "normal" });

    // };

    minutesLeft = (time) => {
        const timeLeft = 300 - 2 * time
        if (timeLeft > 50) {
            return Math.ceil(timeLeft / 60) + " " + 'minutes left'.translate(this.props.lang)
        }
        if (timeLeft <= 10) {
            return '10 seconds left'.translate(this.props.lang)
        }
        if (timeLeft <= 20) {
            return '20 seconds left'.translate(this.props.lang)
        }
        if (timeLeft <= 30) {
            return '30 seconds left'.translate(this.props.lang)
        }
        if (timeLeft <= 40) {
            return '40 seconds left'.translate(this.props.lang)
        }
        if (timeLeft <= 50) {
            return '50 seconds left'.translate(this.props.lang)
        }
    }

    percentageLeft = (current, amount) => {
        // going from 100% do 0%
        return Math.floor(((amount - current) / amount) * 100)
    }

    generateDropDownText = () => {
        return <div style={{ width: 300 }}>
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', cursor: 'pointer' }} onClick={() => {
                    this.setState({
                        showHelpDropDown: !this.state.showHelpDropDown,
                        // showReaderDropDown: false
                    }, () => {
                        // this.updateMode()
                    })
                }}>
                    <h5>{"Help with scanning the QR code".translate(this.props.lang)}</h5>
                    <div style={{ transform: `rotate(90deg)`, fontSize: 24 }}>{">"}</div>
                </div>
                {
                    this.state.showHelpDropDown ?
                        <div style={{ textAlign: 'left' }}>
                            <ol>
                                <li>{'Open the BankID app'.translate(this.props.lang)}</li>
                                <li>{"Press the button 'Scan QR code'".translate(this.props.lang)}</li>
                                <li>{"Aim the phone's camera towards the QR code".translate(this.props.lang)}</li>
                                <li>{'Follow the instructions in the app'.translate(this.props.lang)}</li>
                            </ol>
                            <p style={{ padding: 10 }}>
                                {"The QR code is shown for 5 minutes before the identification is cancelled for security reasons. You can try again if that happens.".translate(this.props.lang)}
                            </p>
                            <p style={{ padding: 10 }}>
                                {"Make sure the entire QR code fits on the screen, otherwise it can't be scanned.".translate(this.props.lang)}

                            </p>
                        </div>
                        :
                        null
                }
            </div>
            <hr />
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', cursor: 'pointer' }} onClick={() => {
                    this.setState({
                        showReaderDropDown: !this.state.showReaderDropDown,
                        // showHelpDropDown: false
                    }, () => {
                        // this.updateMode()
                    })
                }}>
                    <h5>{"If you use a screen reader".translate(this.props.lang)}</h5>
                    <div style={{ transform: `rotate(90deg)`, fontSize: 24 }}>{">"}</div>
                </div>
                {
                    this.state.showReaderDropDown ?
                        <div style={{ textAlign: 'left' }}>
                            <p style={{ padding: 10 }}>
                                {"The most common issue is that the entire QR code doesn't fit on the screen. Please try to:".translate(this.props.lang)}

                            </p>
                            <ul>
                                <li>{'Ensure that the screen is switched on and Screen Curtain or similar functions are switched off.'.translate(this.props.lang)}</li>
                                <li>
                                    <div>
                                        {'Zoom out in your browser by using short command:'.translate(this.props.lang)}
                                    </div>
                                    <ul>
                                        <li>{'Windows: Ctrl+0'.translate(this.props.lang)}</li>
                                        <li>{'Mac: Cmd+0'.translate(this.props.lang)}</li>
                                    </ul>
                                </li>
                                <li>{'Zoom out with magnification tools such as ZoomText.'.translate(this.props.lang)}</li>
                                <li>
                                    <div>
                                        {'Ensure the browser window is maximized by:'.translate(this.props.lang)}
                                    </div>
                                    <ul>
                                        <li>{'Clicking the QR code above'.translate(this.props.lang)}</li>
                                        <li>
                                            <div>
                                                {'Using the short commands:'.translate(this.props.lang)}
                                            </div>
                                            <ul>
                                                <li>{'Windows: Ctrl+Arrow up'.translate(this.props.lang)}</li>
                                                <li>{'Mac: Ctrl+F'.translate(this.props.lang)}</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li>{'Hold your phone in portrait mode 40cm from the screen when you scan the QR code.'.translate(this.props.lang)}</li>
                            </ul>
                        </div>
                        :
                        null
                }
            </div>
            <hr />
        </div>
    }

    render() {
        let redirect_url = this.state.redirect_url;

        let redirect_url_mob;
        if (this.state.isMobile) {
            let parsedObject = parseBankIdUrl(this.state.redirect_url);
            if (parsedObject?.autostarttoken) {
                redirect_url_mob = `https://app.bankid.com/?autostarttoken=${parsedObject?.autostarttoken}&redirect=${parsedObject?.redirect}`
                redirect_url = redirect_url_mob;

            }
        }


        return (

            <div className='bank-id-checkout-v6' ref={(node) => { this.wrapRef = node }}>

                {
                    this.state.isFullScreen && (document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement || (this.wrapRef && this.wrapRef.classList.contains('fs-sim'))) ?
                        <div style={{ height: 40 }}>
                            <Button className='exit-button-full-screen' onClick={async () => {
                                const el = this.wrapRef;

                                const exitFS = async () => {
                                    try {
                                        await (document.exitFullscreen?.() ||
                                            document.webkitExitFullscreen?.() ||
                                            document.msExitFullscreen?.());
                                    } catch (e) { console.error(e); }
                                };

                                // iOS Safari cannot fullscreen arbitrary elements; fallback to CSS
                                const isIOS = /iP(hone|ad|od)/.test(navigator.userAgent);

                                if (!isIOS) {
                                    await exitFS();
                                } else {
                                    // fallback toggle
                                    const on = !el.classList.contains('fs-sim');
                                    el.classList.toggle('fs-sim', on);
                                    document.documentElement.classList.toggle('no-scroll', on);
                                }

                                this.setState({
                                    isFullScreen: false
                                })
                                // this.updateMode()
                            }}>
                                <div>
                                    {'Exit full screen'.translate(this.props.lang)}
                                </div>
                                <div style={{ height: 30, width: 30, borderRadius: '50%', color: 'white', background: '#568AC8', display: 'flex', justifyContent: 'center', alignItems: 'center', marginLeft: 20 }}>X</div>
                            </Button>
                        </div>
                        :
                        null
                }


                {
                    this.state.qrCodeLink && !this.state.qrCodeExpired && !this.state.qrCodePendingSign && (this.state.mode === 'top' || this.state.mode === 'bottom') && !(document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement || (this.wrapRef && this.wrapRef.classList.contains('fs-sim'))) ?

                        <div style={
                            this.state.mode === 'top' && !document.fullscreenElement ? {
                                position: 'fixed',
                                top: 0,
                                display: 'flex', flexDirection: 'column', alignItems: 'center'
                            } : this.state.mode === 'bottom' && !document.fullscreenElement ? {
                                position: 'fixed',
                                bottom: 0,
                                display: 'flex', flexDirection: 'column', alignItems: 'center'
                            } : { display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <button onClick={async () => {
                                const el = this.wrapRef;
                                if (!el) return;

                                const isFS = () =>
                                    document.fullscreenElement ||
                                    document.webkitFullscreenElement ||
                                    document.msFullscreenElement;

                                const canFS = !!(
                                    el.requestFullscreen ||
                                    el.webkitRequestFullscreen ||
                                    el.msRequestFullscreen
                                );

                                const enterFS = async () => {
                                    try {
                                        await (el.requestFullscreen?.() ||
                                            el.webkitRequestFullscreen?.() ||
                                            el.msRequestFullscreen?.());
                                    } catch (e) { console.error(e); }
                                };

                                const exitFS = async () => {
                                    try {
                                        await (document.exitFullscreen?.() ||
                                            document.webkitExitFullscreen?.() ||
                                            document.msExitFullscreen?.());
                                    } catch (e) { console.error(e); }
                                };

                                // iOS Safari cannot fullscreen arbitrary elements; fallback to CSS
                                const isIOS = /iP(hone|ad|od)/.test(navigator.userAgent);

                                if (canFS && !isIOS) {
                                    if (isFS()) await exitFS();
                                    else await enterFS();
                                } else {
                                    // fallback toggle
                                    const on = !el.classList.contains('fs-sim');
                                    el.classList.toggle('fs-sim', on);
                                    document.documentElement.classList.toggle('no-scroll', on);
                                }

                                // this.updateMode()
                                this.setState({
                                    isFullScreen: !this.state.isFullScreen
                                })
                            }} aria-label='QR code, scan with BankID app, hold your phone in portrait mode 40cm from the screen. Click to enter full screen' >
                                <img id='qr-image' onLoad={() => {
                                    this.setState({
                                        imageLoaded: true
                                    })
                                }} alt='QR code. Click for fullscreen' src={this.state.qrCodeLink} style={{ height: 'auto', maxWidth: 185, width: 185 }} />
                            </button>

                            {
                                this.state.qrCodeTimeExpiration ?
                                    <div style={{ marginBottom: 5 }}>
                                        <div style={{ position: 'relative', width: 150, height: 12, overflow: 'hidden', alignItems: 'center', marginBottom: 10 }}>
                                            <div style={{ height: '100%', background: 'rgb(24 62 79 / var(--tw-bg-opacity, 1))', transition: 'width .35s ease', width: `${this.percentageLeft(this.state.qrCodeTimeExpiration, 150)}%` }} />
                                        </div>
                                        <div aria-live style={{ display: 'flex', background: 'white', alignItems: 'center', justifyContent: 'center', font: '12px', color: 'black' }}>{this.minutesLeft(this.state.qrCodeTimeExpiration)}</div>
                                    </div>
                                    :
                                    null
                            }
                            {
                                this.state.qrCodeTimeExpiration && (300 - 2 * this.state.qrCodeTimeExpiration) <= 30 ?
                                    <Button style={{ backgroundColor: '#568AC8', marginBottom: 20 }} onClick={() => {
                                        this.setState({
                                            qrCodeExpired: false,
                                            qrCodeTimeExpiration: 1
                                        }, () => {
                                            this.logIn()
                                        })

                                    }}>{'Extend time'.translate(this.props.lang)}</Button>
                                    :
                                    null
                            }

                        </div>
                        :
                        null
                }
                {
                    this.props.connect ?
                        <h3 >{'Connect using Mobile BankID'.translate(this.props.lang)}</h3>
                        :
                        <h3 >{'Login using Mobile BankID'.translate(this.props.lang)}</h3>
                }


                {
                    this.state.loading && (!this.state.qrCodeLink || this.state.qrCodePendingSign) ?

                        <div className="loader-wrap">
                            {
                                this.state.qrCodePendingSign ?
                                    <h3>{'Security code'.translate(this.props.lang)}</h3>
                                    :
                                    null
                            }
                            <Player
                                autoplay={true}
                                loop={true}
                                src="/lf30_editor_l5cxzdyf.json"
                                style={{
                                    height:
                                        typeof window != "undefined" &&
                                            window.innerWidth < 768
                                            ? "128px"
                                            : "256px",
                                    width:
                                        typeof window != "undefined" &&
                                            window.innerWidth < 768
                                            ? "128px"
                                            : "256px",
                                }}
                            ></Player>
                            {
                                this.state.qrCodePendingSign ?
                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                        <p>{"Enter your security code in the BankID app and select Identify.".translate(this.props.lang)}</p>

                                        {
                                            this.generateDropDownText()
                                        }
                                    </div>
                                    :
                                    null
                            }

                        </div>
                        :
                        this.state.qrCodeLink && !this.state.qrCodeExpired && !this.state.qrCodePendingSign ?
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                <p id="above-qr-image-p">
                                    {"Please start the BankID app and scan the QR code".translate(this.props.lang)}
                                </p>
                                <div id={'qr-image-div'} ref={(node) => this.qrImage = node} style={
                                    this.state.mode === 'top' && !(document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement || (this.wrapRef && this.wrapRef.classList.contains('fs-sim'))) ? {
                                        opacity: 0,
                                        pointerEvents: 'none',
                                        // position: 'fixed',
                                        // top: 0,
                                        // display: 'flex', flexDirection: 'column', alignItems: 'center'
                                    } : this.state.mode === 'bottom' && !(document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement || (this.wrapRef && this.wrapRef.classList.contains('fs-sim'))) ? {
                                        opacity: 0,
                                        pointerEvents: 'none',
                                        // position: 'fixed',
                                        // bottom: 0,
                                        // display: 'flex', flexDirection: 'column', alignItems: 'center'
                                    } : { display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <button ref={(node) => this.qrCodeButton = node} onClick={async () => {
                                        const el = this.wrapRef;
                                        if (!el) return;

                                        const isFS = () =>
                                            document.fullscreenElement ||
                                            document.webkitFullscreenElement ||
                                            document.msFullscreenElement;

                                        const canFS = !!(
                                            el.requestFullscreen ||
                                            el.webkitRequestFullscreen ||
                                            el.msRequestFullscreen
                                        );

                                        const enterFS = async () => {
                                            try {
                                                await (el.requestFullscreen?.() ||
                                                    el.webkitRequestFullscreen?.() ||
                                                    el.msRequestFullscreen?.());
                                            } catch (e) { console.error(e); }
                                        };

                                        const exitFS = async () => {
                                            try {
                                                await (document.exitFullscreen?.() ||
                                                    document.webkitExitFullscreen?.() ||
                                                    document.msExitFullscreen?.());
                                            } catch (e) { console.error(e); }
                                        };

                                        // iOS Safari cannot fullscreen arbitrary elements; fallback to CSS
                                        const isIOS = /iP(hone|ad|od)/.test(navigator.userAgent);

                                        if (canFS && !isIOS) {
                                            if (isFS()) await exitFS();
                                            else await enterFS();
                                        } else {
                                            // fallback toggle
                                            const on = !el.classList.contains('fs-sim');
                                            el.classList.toggle('fs-sim', on);
                                            document.documentElement.classList.toggle('no-scroll', on);
                                        }

                                        // this.updateMode()
                                        this.setState({
                                            isFullScreen: !this.state.isFullScreen
                                        })
                                    }} aria-label='QR code, scan with BankID app, hold your phone in portrait mode 40cm from the screen. Click to enter full screen' >
                                        <img id='qr-image' onLoad={() => {
                                            this.setState({
                                                imageLoaded: true
                                            })
                                        }} alt='QR code. Click for fullscreen' src={this.state.qrCodeLink} style={{ height: 'auto', maxWidth: 185, width: 185 }} />

                                    </button>

                                    {
                                        this.state.qrCodeTimeExpiration ?
                                            <div style={{ marginBottom: 5 }}>
                                                <div style={{ position: 'relative', width: 150, height: 12, overflow: 'hidden', alignItems: 'center', marginBottom: 10 }}>
                                                    <div style={{ height: '100%', background: 'rgb(24 62 79 / var(--tw-bg-opacity, 1))', transition: 'width .35s ease', width: `${this.percentageLeft(this.state.qrCodeTimeExpiration, 150)}%` }} />
                                                </div>
                                                <div aria-live style={{ display: 'flex', background: 'white', alignItems: 'center', justifyContent: 'center', font: '12px', color: 'black' }}>{this.minutesLeft(this.state.qrCodeTimeExpiration)}</div>
                                            </div>
                                            :
                                            null
                                    }
                                    {
                                        this.state.qrCodeTimeExpiration && (300 - 2 * this.state.qrCodeTimeExpiration) <= 30 ?
                                            <Button style={{ backgroundColor: '#568AC8', marginBottom: 20 }} onClick={() => {
                                                this.setState({
                                                    qrCodeExpired: false,
                                                    qrCodeTimeExpiration: 1
                                                }, () => {
                                                    this.logIn()
                                                })

                                            }}>{'Extend time'.translate(this.props.lang)}</Button>
                                            :
                                            null
                                    }

                                </div>
                                <a href={redirect_url} style={{ marginBottom: 20 }} className='btn btn-primary'>{"Open BankID on this device".translate(this.props.lang)}</a>

                                {
                                    this.generateDropDownText()
                                }


                            </div>
                            :
                            this.state.qrCodeExpired ?
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                    <p style={{ color: 'red' }}>{'Due to inactivity, the session has expired'.translate(this.props.lang)}</p>
                                    <Button style={{ backgroundColor: '#568AC8', marginBottom: 20 }} onClick={() => {
                                        this.setState({
                                            qrCodeExpired: false,
                                            qrCodeTimeExpiration: 1
                                        }, () => {
                                            this.logIn()
                                        })
                                    }}>{'Try again'.translate(this.props.lang)}</Button>
                                    {
                                        this.props.goBack ?
                                            <Button style={{ color: 'black', textDecoration: 'underline' }} onClick={() => {
                                                if (this.props.goBack)
                                                    this.props.goBack()
                                            }}>{'Cancel'.translate(this.props.lang)}</Button>
                                            :
                                            null
                                    }

                                </div>
                                :
                                null
                }

                {this.state.errorBankID ?

                    <ErrorModal lang={this.props.lang}
                        isOpen={this.state.errorBankID}
                        toggle={() => this.setState({ errorBankID: null })}

                    >
                        {this.state.errorBankID.translate(this.props.lang)}
                    </ErrorModal>

                    :
                    null
                }
            </div>
        )
    }
}

export default BankIDModal_v6;
